export const PHYSICAL_PERSON_ACCEPTANCE_DECLARATION =
  'Declaro que li, compreendi e concordo integralmente com os termos desta proposta comercial';

export const LEGAL_PERSON_ACCEPTANCE_DECLARATION =
  'Declaro, na qualidade de representante da empresa, que li, compreendi e concordo integralmente com os termos desta proposta comercial';

export function getAcceptanceDeclaration(customerType: 'PF' | 'PJ'): string {
  return customerType === 'PF'
    ? PHYSICAL_PERSON_ACCEPTANCE_DECLARATION
    : LEGAL_PERSON_ACCEPTANCE_DECLARATION;
}

export function canSubmitAcceptance(declarationAccepted: boolean): boolean {
  return declarationAccepted === true;
}
